export class CodigoItem {
    tipoCodigo: string;
    valorCodigo: string;
 }
 